export default "__VITE_ASSET__pWwD9YLR__"